import React, { useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import $ from 'jquery'
import { ResultData } from '../../data/ResultContext'
import { ComponentData } from '../../data/ComponentContext'
import { createFootpintChart, createInvestChart, createMotivationChart, createOutputChart, createPowerChart, createScoreChart } from '../../util/chartCreator'
import { createPdf } from '../../util/pdfRenderer'
import Delete from '../../img/delete.svg'
import Send from '../../img/mail.svg'
import Arrow from '../../img/arrow-right.svg'
import SuccessPopup from '../SuccessPopup'
import ErrorPopup from '../ErrorPopup'
import ReCAPTCHA from 'react-google-recaptcha'

function ResultTab({ toLastTab }) {

  const API_PATH = 'api/'

  const {
    selectedMaterial, selectedColors, selectedSurface,
    selectedGeometry, length, width, height, weight,
    quantity, zone1Energy, zone2Energy, processTemp, ambientTemp,
    heatTime, holdTime, processChartUrl, sliderPoints, Motivations, scores,
    footprintPercentages, powerPercentages, outputPercentages, investPercentages, idealHeatEvent } = ComponentData()

  const {
    name, setName,
    firstName, setFirstName,
    mail, setMail,
    mailConfirm, setMailConfirm,
    company, setCompany,
    consent, setConsent,
    resetConfiguration,
    regexValid,
    resultIsValid
  } = ResultData()

  let motivationChartUrl = useRef('');
  let scoreChartUrl = useRef('');
  let footprintChartUrl = useRef('');
  let powerChartUrl = useRef('');
  let outputChartUrl = useRef('');
  let investChartUrl = useRef('')

  const sendResult = async (e) => {
    e.preventDefault();
    motivationChartUrl.current = await createMotivationChart(sliderPoints);
    scoreChartUrl.current = await createScoreChart(scores);
    footprintChartUrl.current = await createFootpintChart(footprintPercentages);
    powerChartUrl.current = await createPowerChart(powerPercentages);
    outputChartUrl.current = await createOutputChart(outputPercentages);
    investChartUrl.current = await createInvestChart(investPercentages);

    sendPDF();
  }

  const form = useRef(null)

  const sendPDF = async () => {
    let pdfBlob = await createPdf(
      name, firstName, motivationChartUrl.current, scoreChartUrl.current,
      sliderPoints, Motivations, selectedMaterial, selectedColors,
      selectedSurface, selectedGeometry, length, width, height, weight,
      quantity, zone1Energy, zone2Energy, processTemp, ambientTemp, heatTime, holdTime, processChartUrl.current,
      footprintChartUrl.current, powerChartUrl.current, outputChartUrl.current, investChartUrl.current, idealHeatEvent
    )

    // DEVELOPMENT
    // let pdfURL = URL.createObjectURL(pdfBlob)
    // let pdfWindow = window.open()
    // pdfWindow.location.href = pdfURL
    // setSuccess(true);

    // PRODUCTION
    let formData = new FormData();
    formData.append('pdf', pdfBlob, "pdfBlob");
    formData.set('firstName', firstName);
    formData.set('name', name);
    formData.set('mail', mail);
    formData.set('company', company);
    $.ajax({
      url: API_PATH,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false
    }).then(response => {
      setSuccess(true);
    }).catch(err => {
      setError(true);
    }
    )
  }

  $(() => {
    $(window).on('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        return false
      }
    })
  })

  const [nameIsValid, setNameIsValid] = useState(true)
  const [firstNameIsValid, setFirstNameIsValid] = useState(true)
  const [companyIsValid, setCompanyIsValid] = useState(true)
  const [mailFieldIsValid, setMailFieldIsValid] = useState(true)
  const [mailConfirmIsValid, setMailConfirmIsValid] = useState(true)
  const [captchaValue, setCaptchaValue] = useState(null)

  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)

  return (
    <div className="result-tab">
      <div className="content-box">
        <h2>Ihr Ergebnis</h2>
        <p>Das Ergebnis wird Ihnen via E-Mail bereitgestellt.</p>
      </div>
      <form method='post' onSubmit={(event) => {
        sendResult(event)
      }} ref={form}>

        <div>
          <Row className="headline_texts">
            <div className="configuration-text">
              <h3>Ihre Daten</h3>
            </div>
          </Row>
          <div className='configuration-area'>
            <Row>
              <Col md={6}>
                <div className={nameIsValid ? "content-box" : 'content-box error'}>
                  <input
                    type="text"
                    className='full-width'
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value)
                      setNameIsValid(true)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value || e.target.value === '') {
                        setNameIsValid(false)
                      }
                    }} />
                  <label>Nachname</label>
                </div>
              </Col>

              <Col md={6}>
                <div className={firstNameIsValid ? "content-box" : 'content-box error'}>
                  <input
                    type="text"
                    className='full-width'
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value)
                      setFirstNameIsValid(true)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value || e.target.value === '') {
                        setFirstNameIsValid(false)
                      }
                    }} />
                  <label>Vorname</label>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className={companyIsValid ? "content-box" : 'content-box error'}>
                  <input
                    type="text"
                    className='full-width'
                    value={company}
                    onChange={(e) => {
                      setCompany(e.target.value)
                      setCompanyIsValid(true)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value || e.target.value === '') {
                        setCompanyIsValid(false)
                      }
                    }} />
                  <label>Firmenname</label>
                </div>
              </Col>
            </Row>

            <Row>

              <Col md={6}>
                <div className={mailFieldIsValid ? "content-box" : 'content-box error'}>
                  <input
                    type="text"
                    className='full-width'
                    value={mail}
                    onChange={(e) => {
                      setMail(e.target.value)
                      setMailFieldIsValid(true)
                    }}
                    onBlur={(e) => {
                      if (!regexValid) {
                        setMailFieldIsValid(false)
                      }
                    }} />
                  <label>E-Mail Adresse</label>
                </div>
              </Col>

              <Col md={6}>
                <div className={mailConfirmIsValid ? "content-box" : 'content-box error'}>
                  <input
                    type="text"
                    className='full-width'
                    value={mailConfirm}
                    onChange={(e) => {
                      setMailConfirm(e.target.value)
                      setMailConfirmIsValid(true)
                    }}
                    onBlur={(e) => {
                      if (e.target.value !== mail) {
                        setMailConfirmIsValid(false)
                      }
                    }} />
                  <label>E-Mail bestätigen</label>
                </div>
              </Col>
            </Row>
          </div>

          <div className="datenschutz">
            <input className="data-checkbox" type="checkbox"
              checked={consent}
              onChange={(e) => { setConsent(e.target.checked) }} />
            <label>Ich bin mit der Verarbeitung meiner personenbezogenen Daten gem. Art. 7 DSGVO einverstanden. Weitere Infos in unserer <a href='https://www.weiss-technik.com/de/legal/datenschutzrichtlinien/' target='_blank' rel='noreferrer'>Datenschutzerklärung</a>.</label>
          </div>
          <ReCAPTCHA sitekey='6LeOdHIUAAAAALB6zXe3NiOjAXyr2R7leTytNxtB' onChange={(val) => setCaptchaValue(val)} />

        </div>

        <div className="button-box">
          <button onClick={resetConfiguration} type="button" className='delete'>Zurücksetzen <img className="button-svg" src={Delete} alt='' /></button>
          <button onClick={toLastTab} type='button'><img className="button-svg back" src={Arrow} alt='' />Zurück</button>
          <button disabled={!resultIsValid || !captchaValue} type="submit">Senden <img className="button-svg" src={Send} alt='' /></button>
        </div>

      </form>

      {/* Versteckte Canvas-Elemente für ChartCreator */}
      <div className="canvas-container">
        <canvas id='motivation-chart-canvas'> </canvas>
      </div>
      <div className="canvas-container score-chart">
        <canvas id='score-chart-canvas'> </canvas>
      </div>
      <div className="canvas-container footprint-chart">
        <canvas id='footprint-chart-canvas'> </canvas>
      </div>
      <div className="canvas-container power-chart">
        <canvas id='power-chart-canvas'> </canvas>
      </div>
      <div className="canvas-container output-chart">
        <canvas id='output-chart-canvas'> </canvas>
      </div>
      <div className="canvas-container invest-chart">
        <canvas id='invest-chart-canvas'> </canvas>
      </div>

      {success && <SuccessPopup />}
      {error && <ErrorPopup />}

    </div>

  )
}

export default ResultTab